/* eslint-disable import/no-extraneous-dependencies */
import React from 'react'
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker'
import dayjs, { Dayjs } from 'dayjs'
import { KeyboardArrowDown } from '@mui/icons-material'
import { datePickerPopperStyles, datePickerStyles } from './DatePicker.styles'

export type DateRangeValue = [Dayjs | null, Dayjs | null]

interface DatePickerProps {
  label: string
  widthFitContent?: boolean
  value?: DateRangeValue
  onChange?: (value: DateRangeValue) => void
  maxDate?: Dayjs
  minDate?: Dayjs
}

function DatePicker(props: DatePickerProps) {
  const { label, widthFitContent, value, onChange, maxDate, minDate } = props
  const today = dayjs()
  const defaultValue = React.useMemo<DateRangeValue>(
    () => [today, today],
    [today]
  )

  const isControlled = value !== undefined

  return (
    <DateRangePicker
      calendars={1}
      label={label}
      sx={{
        ...datePickerStyles,
        width: widthFitContent ? 'fit-content' : '100%'
      }}
      maxDate={maxDate ?? today}
      minDate={minDate}
      value={isControlled ? value : undefined}
      defaultValue={isControlled ? undefined : defaultValue}
      onChange={
        onChange
          ? newValue => onChange(newValue as DateRangeValue)
          : undefined
      }
      slots={{
        switchViewIcon: KeyboardArrowDown
      }}
      slotProps={{
        popper: {
          sx: datePickerPopperStyles
        },
        switchViewButton: {
          disableRipple: true
        },
        nextIconButton: {
          disableRipple: true
        },
        previousIconButton: {
          disableRipple: true
        },
        day: {
          disableRipple: true
        },
        openPickerButton: {
          disableRipple: true
        }
      }}
    />
  )
}

export default DatePicker
